module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Document Checklist")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.showDocumentDialog(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add_circle")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.lender) + "\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.lenders), function(lender) {
    return _c('v-list-item', {
      key: lender.key,
      on: {
        "click": function($event) {
          return _vm.showDocumentDialog(null, _vm.category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(lender.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.documents), function(document) {
    return _c('div', {
      key: document.key
    }, [_c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(document.title))]), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_c('b', [_vm._v(_vm._s(_vm.getPreferredOption(document).title))])]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.getPreferredOption(document).description) + " \n             | "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOptionDialog(document.key, document.preferredIndex, _vm.getPreferredOption(document))
        }
      }
    }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
      staticClass: "mb-3 mt-3"
    }, [_vm._v("\n            Other Options: \n            "), _vm._l((document.options), function(option, index) {
      return [(true) ? _c('span', {
        key: index
      }, [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setPreferredIndex(document, index)
          }
        }
      }, [_vm._v(_vm._s(option.title))]), _vm._v(" | \n                ")]) : _vm._e()]
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showOptionDialog(document.key, null, null)
        }
      }
    }, [_vm._v("Create New Option")])], 2)])
  })], 2), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "settings": _vm.documentDialog.settings
    },
    on: {
      "save": _vm.saveDocumentDialog
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-text-field', {
    ref: "documentTitle",
    attrs: {
      "label": "Title",
      "maxlength": "30"
    },
    on: {
      "change": _vm.setDefaultName
    },
    model: {
      value: (_vm.documentDialog.document.title),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.document, "title", $$v)
      },
      expression: "documentDialog.document.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.documentDialog.document.name),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.document, "name", $$v)
      },
      expression: "documentDialog.document.name"
    }
  })], 1)]), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "settings": _vm.optionDialog.settings
    },
    on: {
      "save": _vm.saveOptionDialog
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-text-field', {
    ref: "optionTitle",
    attrs: {
      "label": "Title",
      "maxlength": "30"
    },
    model: {
      value: (_vm.optionDialog.option.title),
      callback: function($$v) {
        _vm.$set(_vm.optionDialog.option, "title", $$v)
      },
      expression: "optionDialog.option.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description"
    },
    model: {
      value: (_vm.optionDialog.option.description),
      callback: function($$v) {
        _vm.$set(_vm.optionDialog.option, "description", $$v)
      },
      expression: "optionDialog.option.description"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edc337fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LenderDocuments.vue
// module id = 2666
// module chunks = 1